"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var styles_1 = require("./styles");
function Item(props) {
    var setIsMenuOpen = index_1.useDropdown().setIsMenuOpen;
    var onClick = props.onClick, children = props.children, restProps = __rest(props, ["onClick", "children"]);
    return (react_1.default.createElement(styles_1.MainContainer, __assign({}, restProps, { onClick: function (event) {
            event.stopPropagation();
            props.onClick && props.onClick(event);
            setIsMenuOpen(false);
        } }), children));
}
exports.default = Item;
//# sourceMappingURL=index.js.map